(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductGrid;
        if (!Orig) return;

        class ProductGridPatched extends Orig {
            get_stock_availability(item, settings){
                let stock_html = super.get_stock_availability(item, settings) || "";
                let bulk_html = item["bulk_prices_html"] || "";
                let content = stock_html + bulk_html;
                return `<div class="bulk-prices-wrapper">${content}</div>`;
            }
        }
        webshop.ProductGrid = ProductGridPatched;
    });
})();
